import gsap from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.hasMotion ) {
        $( '.two-column-line-draw' ).addClass( 'js-animated' );
        return;
      }

      $( '.two-column-line-draw' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( val ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( val ).addClass( 'js-animated' );
            },
            scrub: 0,
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'two-column-line-draw', COMPONENT );
} )( app );
